<template>
  <FHTabs :key="tabKey">
    <div class="tab-results" v-for="type in contentTypes" :key="type">
      <FHTab :name="typeName(type)" :isDisabled="tabData(type).length == 0">
        <SearchResult
          v-for="result in tabData(type)"
          :key="result._id"
          :title="mappedData[result._source.content_type].title(result)"
          :description="mappedData[result._source.content_type].description(result, term)"
          :type="mappedData[result._source.content_type].type(result)"
          :image="mappedData[result._source.content_type].image(result)"
          :unitID="mappedData[result._source.content_type].unitID(result)"
          :term="term"
          :link="mappedData[result._source.content_type].link(result, getUnit(mappedData[result._source.content_type].unitID(result)).slug, term)"
          :fullTags="result._source.tags"
          :unit="getUnit(mappedData[result._source.content_type].unitID(result))">
        </SearchResult>
        <slot></slot>
        <span v-if="tabData(type).length == 0">{{`No results for ${type.replace(/_/g,' ')}`}}</span>
      </FHTab>
    </div>
  </FHTabs>
</template>

<script>
import SearchResult from './FHSearchResult'
import mappedData from './mapResults.js'
import FHTabs from '@forlagshuset/v-tabs/FHTabs'
import FHTab from '@forlagshuset/v-tabs/FHTab'

export default {
  name: "SearchResultsCats",

  components: {
    SearchResult,
    FHTab,
    FHTabs
  },

  created() {
    this.setAllTab()
  },

  props: {
    term: String,
    contentTypes: Array,
    results: Array,
    units: Array,
    showAllTab: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      mappedData: mappedData,
      tabKey: ''
    }
  },
  methods: {
    setAllTab() {
      if (this.showAllTab && !this.contentTypes.includes('All')) {
        this.contentTypes.unshift('All')
      }
      this.setTabKey()
    },
    setTabKey() {
      this.tabKey = `${this.term}-${this.results.length}-${this.contentTypes.length}`
    }
  },
  computed: {
    typeName() {
      return type => {
        return `${this.$t('SEARCH_LABEL_' + type.toUpperCase())} (${this.tabData(type).length})`
      }
    },
    tabData() {
      return type => {
        return this.showAllTab && type === 'All' ? this.results : this.results.filter(i => i._source.content_type === type)
      }
    },
    getUnit() {
      return unitID => {
        let units = this.units.filter(unit => unit.id === unitID)
        if (units.length == 0) {
          return null
        }
        return units[0]
      }
    }
  },
  watch: {
    'results': function() {
      this.tabKey = `${this.term}-${this.results.length}`
    },
    'showAllTab' : function() {
      this.setAllTab()
    }
  }
}
</script>
